angular.module('lf.desktop')

.factory('notificationService', function () {
  
  return {
    show: angular.noop,
    hide: angular.noop
  }
  
});
